function get_external_app_url(path) {
	let m;

	if (typeof path == 'string' && (m = path.match(/^(http|https)(:[0-9]{1,6})$/))) {
		return m[1] + '://' + location.hostname + m[2];
	}

	return path;
}

[{
	id: 'freepbx',
	access: 'freepbx',
	title: _('Administrace PBX'),
	tagline: _('Administrace ústředny'),
	icon: 'freepbx',
	href: get_external_app_url(env.FREEPBX_URL),
	href_target: '_blank',
}, {
	id: 'tts',
	access: 'tts',
	title: _('TextToSpeech'),
	tagline: _('Převod textu na řeč'),
	icon: 'texttospeech',
	href: get_external_app_url(env.TTS_URL),
	href_target: '_blank',
}, {
	id: 'provisioning',
	access: 'provisioning',
	title: _('Provisioning'),
	tagline: _('Nastavení HW telefonů'),
	icon: 'settings',
	href: get_external_app_url(env.PROVISIONING_URL),
	href_target: '_blank',
}, {
	id: 'mluvii',
	access: 'mluvii',
	title: _('Mluvii'),
	tagline: _('All-in-one komunikační platforma pro péči o zákazníky'),
	icon: 'mluvii',
	href: get_external_app_url(env.MLUVII_URL),
	href_target: '_blank',
}].filter(app => app.href).forEach(app => Application.registerModule(app));
